import { render, staticRenderFns } from "./CsvDownloadButton.vue?vue&type=template&id=1a5f784b&scoped=true"
import script from "./CsvDownloadButton.vue?vue&type=script&lang=ts"
export * from "./CsvDownloadButton.vue?vue&type=script&lang=ts"
import style0 from "./CsvDownloadButton.vue?vue&type=style&index=0&id=1a5f784b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5f784b",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/csv-download-button.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2FCsvDownloadButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports